module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-10-66cf08c259caad6693f8504542873034.png";